import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const scrollToProducts = () => {
  const el = document.getElementById('producten');
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export const EEHero = () => {
  const { t } = useTranslation();

  return (
  <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
    <div className="absolute inset-0">
      <img
        src="https://public.readdy.ai/ai/img_res/f090a1d4522f983c8a4d5011975f17e0.jpg"
        alt="Evil Energy Protect"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0d0000]/85 via-[#0d0000]/70 to-[#0d0000]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0d0000]/60 via-transparent to-[#0d0000]/60" />
    </div>

    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {[...Array(12)].map((_, i) => (
        <div key={i} className="absolute w-1 h-1 rounded-full bg-red-500/40"
          style={{ left: `${8 + i * 8}%`, top: `${20 + (i % 4) * 18}%`, animation: `pulse ${2 + (i % 3)}s ease-in-out infinite`, animationDelay: `${i * 0.4}s` }} />
      ))}
    </div>

    <div className="relative z-10 w-full text-center px-6 lg:px-12 flex flex-col items-center">
      <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-900/30 border border-red-500/30 rounded-full mb-8">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-shield-flash-line text-red-400 text-xs" />
        </div>
        <span className="text-red-300 text-xs font-semibold uppercase tracking-widest">{t('ee_hero_badge')}</span>
      </div>

      <h1 className="text-5xl lg:text-7xl font-black text-white mb-6 leading-tight">
        Evil Energy<br />
        <span className="text-transparent bg-gradient-to-r from-red-400 via-orange-400 to-red-500 bg-clip-text">
          {t('ee_hero_title')}
        </span>
      </h1>

      <p className="text-white/55 text-base lg:text-lg max-w-2xl mx-auto leading-relaxed mb-4">{t('ee_hero_sub')}</p>
      <p className="text-red-300/70 text-sm max-w-xl mx-auto leading-relaxed mb-12">{t('ee_hero_pure')}</p>

      <div className="flex flex-col sm:flex-row items-center gap-4 mb-16">
        <button onClick={scrollToProducts}
          className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-red-700 to-orange-700 text-white font-bold text-sm rounded-full hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-shopping-bag-line text-sm" />
          </div>
          {t('ee_hero_view')}
        </button>
        <a href="#producten"
          className="inline-flex items-center gap-2 px-8 py-4 bg-white/5 border border-white/15 text-white/80 font-semibold text-sm rounded-full hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-down-line text-sm" />
          </div>
          {t('ee_hero_discover')}
        </a>
      </div>

      <div className="flex flex-wrap justify-center gap-8 lg:gap-16">
        {[
          { value: '6×', label: t('ee_hero_stat1') },
          { value: '4.9★', label: t('ee_hero_stat2') },
          { value: '336+', label: t('ee_hero_stat3') },
          { value: '100%', label: t('ee_hero_stat4') },
        ].map(stat => (
          <div key={stat.label} className="text-center">
            <p className="text-red-400 font-black text-2xl lg:text-3xl">{stat.value}</p>
            <p className="text-white/35 text-xs mt-1">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>

    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
      <div className="w-5 h-5 flex items-center justify-center">
        <i className="ri-arrow-down-s-line text-white/30 text-lg" />
      </div>
    </div>
  </section>
  );
};
